import { Link } from 'react-router-dom';
import { hotRoutes } from '@/mocks/homeData';
import FadeInSection from '@/components/base/FadeInSection';

const routeImageUrls: Record<string, string> = {
  'hot-route-1': 'https://readdy.ai/api/search-image?query=Luxury%20overwater%20villa%20at%20sunset%20on%20a%20tropical%20island%2C%20private%20infinity%20pool%20overlooking%20calm%20turquoise%20ocean%2C%20wooden%20deck%20with%20candlelit%20dinner%20setup%20for%20two%2C%20warm%20golden%20hour%20light%2C%20romantic%20and%20exclusive%20atmosphere%2C%20luxury%20travel%20photography&width=900&height=600&seq=hot-route-1-2026&orientation=landscape',
  'hot-route-2': 'https://readdy.ai/api/search-image?query=Couple%20snorkeling%20in%20crystal%20clear%20tropical%20water%20with%20colorful%20coral%20reef%20and%20tropical%20fish%2C%20sunlight%20beams%20penetrating%20through%20water%20surface%2C%20vibrant%20underwater%20scene%2C%20paradise%20island%20view%20from%20above%2C%20professional%20underwater%20photography%20style&width=900&height=600&seq=hot-route-2-2026&orientation=landscape',
  'hot-route-3': 'https://readdy.ai/api/search-image?query=Elegant%20beach%20proposal%20setup%20at%20sunset%20with%20thousands%20of%20rose%20petals%2C%20fairy%20lights%20wrapped%20around%20palm%20trees%2C%20diamond%20ring%20in%20foreground%2C%20champagne%20glasses%2C%20ocean%20horizon%20with%20golden%20sunset%2C%20ultra%20romantic%20atmosphere%2C%20cinematic%20photography&width=900&height=600&seq=hot-route-3-2026&orientation=landscape',
  'hot-route-4': 'https://readdy.ai/api/search-image?query=Convertible%20car%20driving%20along%20scenic%20coastal%20road%20on%20tropical%20island%2C%20turquoise%20ocean%20on%20one%20side%2C%20lush%20green%20hills%20on%20the%20other%2C%20bright%20sunny%20day%2C%20sense%20of%20freedom%20and%20adventure%2C%20road%20trip%20travel%20photography%20with%20vibrant%20colors&width=900&height=600&seq=hot-route-4-2026&orientation=landscape',
};

export default function HotRoutes() {
  return (
    <section className="section-padding bg-background-100">
      <div className="container-wide">
        <FadeInSection>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-12 gap-3">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
                热门推荐线路
              </h2>
              <p className="text-sm text-foreground-500">精选最受欢迎的爱情岛线路，总有一条适合你</p>
            </div>
            <Link
              to="/category/honeymoon"
              className="text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap"
            >
              查看全部线路
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </Link>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {hotRoutes.map((route, index) => (
            <FadeInSection key={route.slug} delay={index * 100}>
              <Link
                to={`/article/${route.slug}`}
                className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-200 hover:bg-background-50/90 block"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                    style={{ backgroundImage: `url('${routeImageUrls[route.imageSeq]}')` }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                      {route.category}
                    </span>
                  </div>
                  <div className="absolute top-3 right-3">
                    <span className="px-2 py-0.5 bg-background-50/90 text-foreground-700 text-xs font-medium rounded-full flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-[10px] text-accent-500"></i>
                      </span>
                      {route.rating}
                    </span>
                  </div>
                </div>

                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {route.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                    {route.summary}
                  </p>
                  <div className="flex items-center gap-1.5 mb-3 flex-wrap">
                    {route.tags.map((tag) => (
                      <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t border-background-200">
                    <span className="text-xs text-foreground-500 flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-time-line text-[11px]"></i>
                      </span>
                      {route.duration}
                    </span>
                    <span className="text-sm font-bold text-primary-600">{route.price}</span>
                  </div>
                </div>
              </Link>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}